export const getBoundaryGap = (
  ticks: number,
  defaultBoundaryGap: [number, number] | [string, string] = ['1%', '1%'],
) => {
  switch (ticks) {
    case 2:
      return [0.5, 0.5];
    case 3:
      return [0.25, 0.25];
    case 4:
      return [0.1, 0.1];
    default:
      return defaultBoundaryGap;
  }
};
